
import { Vue, Component } from "vue-property-decorator";
import DateTimeSection from "@/components/DateTimeSection.vue";
import SettingsCard from "@/components/settings/components/settingsPage/SettingsCard.vue";
import { Getter } from "vuex-class";
import { SettingsGetters, SettingsTitle } from "@/components/settings/types";
import { Namespace } from "@/store/types";
import PinOverlay from "@/components/settings/components/PinOverlay.vue";
import RightSideMenu from "@/components/settings/components/RightSideMenu.vue";
import SettingsConfirmOverlay from "@/components/settings/components/SettingsConfirmOverlay.vue";

@Component({
  components: {
    DateTimeSection,
    SettingsCard,
    PinOverlay,
    RightSideMenu,
    SettingsConfirmOverlay
  }
})
export default class Settings extends Vue {
  @Getter(SettingsGetters.getSettingsPageTitle, {
    namespace: Namespace.Settings
  })
  getSettingsPageTitle!: SettingsTitle;

  @Getter(SettingsGetters.getPinOverlay, { namespace: Namespace.Settings })
  getPinOverlay!: string;

  @Getter(SettingsGetters.getOpenRightSideMenu, {
    namespace: Namespace.Settings
  })
  getOpenRightSideMenu!: string;

  @Getter(SettingsGetters.getOpenConfirmModal, {
    namespace: Namespace.Settings
  })
  getOpenConfirmModal!: boolean;
}
